<cm-time-zone-picker #timezonePicker [attr.data-time-zone]="timezone?.name" (change)="inputChange($event)"></cm-time-zone-picker>
